import videoHelpers from '../helpers/video';
import dataLayerHelper from '../helpers/dataLayer';

const $videoOverlay = $('.js-video-overlay');
const $close = $('.js-video-overlay-close');
const $video = $('.js-video-overlay-video');
const $openVideo = $('.js-open-video');
const $window = $(window);

const videoOverlay = {
  initialize() {
    if ($videoOverlay.length) {
      this.createEvents();

      $openVideo.toArray().forEach((videoBtn) => {
        const $thumb = $(videoBtn).find('.js-open-video-thumb');

        if ($thumb.length) {
          this.fetchThumbs($(videoBtn).data('url'), $thumb);
        }
      });
    }
  },

  createEvents() {
    $window.on('resize', () => {
      this.setVideoHeight();
    });

    $close.on('click', () => {
      this.closeVideo();
    });

    $openVideo.on('click', (e) => {
      e.preventDefault();
      const video = $(e.currentTarget).data('url');
      this.openVideo(video);
    });
  },

  getEmbed(url) {
    const type = (url.indexOf('youtube') >= 0 || url.indexOf('youtu.be') >= 0)
      ? 'youtube' : 'vimeo';
    let embed;

    // YouTube specific code
    if (type === 'youtube') {
      const id = videoHelpers.getYoutubeId(url);
      embed = videoHelpers.createYoutubeEmbed(id);

    // Vimeo specific code
    } else if (type === 'vimeo') {
      const id = videoHelpers.getVimeoId(url);
      embed = videoHelpers.createVimeoEmbed(id);
    }

    return embed;
  },

  setVideoHeight() {
    const CLOSE_HEIGHT = 62;
    const RATIO_16_9 = 0.5625;
    const videoSpace = $window.height() - CLOSE_HEIGHT;

    if (($window.width() * RATIO_16_9) > videoSpace) {
      $video.css({
        paddingBottom: 0,
        height: videoSpace,
      });
    } else {
      $video.css({
        paddingBottom: '56.25%',
        height: 'auto',
      });
    }
  },

  openVideo(url) {
    const embed = this.getEmbed(url);

    $videoOverlay.trigger('show.overlay');

    $video.append(embed);

    $videoOverlay.attr('aria-hidden', false);

    this.setVideoHeight();

    $('body').css('overflow', 'hidden');

    $videoOverlay.addClass('is-visible');

    dataLayerHelper.event('Open video', url, window.location.href);
  },

  closeVideo() {
    $video.html('');

    $videoOverlay.attr('aria-hidden', true);

    $('body').css('overflow', 'visible');

    $videoOverlay.removeClass('is-visible');
  },

  fetchThumbs(url, $thumb) {
    const id = videoHelpers.getYoutubeId(url);
    const poster = videoHelpers.getYoutubePoster(id).replace('maxresdefault', 'hqdefault');

    $thumb.css('background-image', `url(${poster})`);
  },
};

export default videoOverlay;
